import Vue from 'vue'
import Router from './Router'

export default {
	namespaced: true,
	state: {
		list: [],
		meta: null,
		loading: true,
		detail: {},
		isLoadingCreateLandlord: false,
		isLoadingDetail: false
	},
	actions: {
		async fetch({ commit }, query) {
			let response = await Vue.http.get('landlords', { params: query })
			commit('setList', response.body)
		},
		async createLandlord({ commit }, data) {
			try {
				commit('setLoadCreateLandlord', true)
				const response = await Vue.http.post(`landlords`, data)
				Router.push(`landlords/${response.body.id}`)
				commit('setLoadCreateLandlord', false)
			} catch (e) {
				commit('setLoadCreateLandlord', false)
				console.error(e)
			}
		},
		async getLandlord({ dispatch, rootState, commit }, landlordId = false) {
			try {
				commit('setLoadDetail', true)
				let id = landlordId || rootState.route.params.landlordId
				const response = await Vue.http.get(`landlords/${id}`)
				commit('setDetail', response.body)
				commit('setLoadDetail', false)
			} catch (e) {
				commit('setLoadDetail', false)
			}
		},
		async updateLandlord({ dispatch, rootState }, data) {
			let id = rootState.route.params.landlordId
			await Vue.http.post(`landlords/${id}`, data)
			dispatch('getLandlord')
		},

		async createAddress({ rootState, commit }, data) {
			const id = rootState.route.params.landlordId
			let response = await Vue.http.post(`addresses`, { ...data, addressable_id: id })
			data.id = response.body.addressId
			commit('addAddress', data)
		},
		async updateAddress({ commit }, data) {
			await Vue.http.post(`addresses/${data.id}`, data)
			commit('updateAddress', data)
		},
		async deleteAddress({ commit }, id) {
			await Vue.http.delete(`addresses/${id}`)
			commit('deleteAddress', id)
		}
	},
	mutations: {
		setList(state, landlords) {
			state.list = landlords.data
			state.meta = landlords.meta
			state.loading = false
		},
		setDetail(state, landlordDetail) {
			state.detail = { ...landlordDetail }
		},
		setLoadCreateLandlord(state, status) {
			state.isLoadingCreateLandlord = status
		},
		setLoadDetail(state, status) {
			state.isLoadingDetail = status
		},

		addAddress(state, address) {
			state.detail[address.addressable_type] = state.detail[address.addressable_type]
				? [...state.detail[address.addressable_type], address]
				: address
		},
		updateAddress(state, address) {
			if(state.detail.landlord_person_address.id == address.id) {
				state.detail.landlord_person_address = address
			}
			state.detail.landlord_apartment_address = state.detail.landlord_apartment_address.map(
				item => {
					if(item.id === address.id) {
						item = address
					}
					return item
				}
			)
		},
		deleteAddress(state, addressId) {
			state.detail.landlord_apartment_address = state.detail.landlord_apartment_address.filter(
				item => item.id !== addressId
			)
		}
	}
}
